const muiDarkMode = {
	palette: {
		mode: 'dark',
		common: { black: '#000000', white: '#ffffff' },
		primary: {
			main: '#90caf9',
			light: '#bbdefb',
			dark: '#42a5f5',
			contrastText: 'rgba(0,0,0,0.87)',
		},
		secondary: {
			main: '#ce93d8',
			light: '#e1bee7',
			dark: '#ab47bc',
			contrastText: 'rgba(0,0,0,0.87)',
		},
		sds: {
			main: '#90caf9',
			light: '#bbdefb',
			dark: '#42a5f5',
			contrastText: 'rgba(0,0,0,0.87)',
		},
		error: {
			main: '#f44336',
			light: '#e57373',
			dark: '#d32f2f',
			contrastText: '#ffffff',
		},
		warning: {
			main: '#ffa726',
			light: '#ffb74d',
			dark: '#f57c00',
			contrastText: 'rgba(0,0,0,0.87)',
		},
		info: {
			main: '#29b6f6',
			light: '#4fc3f7',
			dark: '#0288d1',
			contrastText: 'rgba(0,0,0,0.87)',
		},
		success: {
			main: '#66bb6a',
			light: '#81c784',
			dark: '#388e3c',
			contrastText: 'rgba(0,0,0,0.87)',
		},
		grey: {
			50: '#fafafa',
			100: '#f5f5f5',
			200: '#eeeeee',
			300: '#e0e0e0',
			400: '#bdbdbd',
			500: '#9e9e9e',
			600: '#757575',
			700: '#616161',
			800: '#424242',
			900: '#212121',
			A100: '#f5f5f5',
			A200: '#eeeeee',
			A400: '#bdbdbd',
			A500: '#9e9e9e',
			A600: '#757575',
			A700: '#616161',
		},
		contrastThreshold: 3,
		tonalOffset: 0.2,
		text: {
			primary: '#ffffff',
			secondary: 'rgba(255, 255, 255, 0.7)',
			disabled: 'rgba(255, 255, 255, 0.5)',
			icon: 'rgba(255,255,255,0.12)',
		},
		divider: 'rgba(255, 255, 255, 0.12)',
		background: { paper: '#1A2332', default: '#0F1419' },
		action: {
			active: '#ffffff',
			hover: 'rgba(255, 255, 255, 0.08)',
			hoverOpacity: 0.08,
			selected: 'rgba(255, 255, 255, 0.08)',
			selectedOpacity: 0.16,
			disabled: 'rgba(255, 255, 255, 0.3)',
			disabledBackground: 'rgba(255, 255, 255, 0.12)',
			disabledOpacity: 0.38,
			focus: 'rgba(255, 255, 255, 0.12)',
			focusOpacity: 0.12,
			activatedOpacity: 0.24,
		},
	},
	components: {},
};
export default muiDarkMode;
